/* eslint-disable no-useless-escape */
import * as Yup from 'yup';

import MESSAGES from './messagesValidations';

import { validateEmail, validateCpf } from './generalFunctions';
import { dateIsFuture, dateIsOlderThan } from './date';

const VALIDATIONS = {
  requiredString: Yup.string().required(MESSAGES.requiredField),
  numero: Yup.string()
    .required('Campo obrigatório')
    .matches(/^([0-9]+)$/, '* Somente números'),
  email: Yup.string()
    .trim()
    .required(MESSAGES.email.required)
    .max(64, MESSAGES.email.maxCharacters)
    .test(
      'valid-email',
      MESSAGES.email.invalid,
      email => email && validateEmail(email)
    ),
  cpf: Yup.string()
    .required(MESSAGES.cpf.invalid)
    // eslint-disable-next-line no-useless-escape
    .matches(/^\d{3}\.\d{3}\.\d{3}\-\d{2}$/, {
      message: MESSAGES.cpf.invalid,
    })
    .test(
      'valida-cpf',
      MESSAGES.cpf.invalid,
      cpfNumber => cpfNumber && validateCpf(cpfNumber.replace(/\D/g, ''))
    ),
  cnpj: Yup.string()
    .required(MESSAGES.requiredField)
    .matches(/^[0-9A-Z]{2}\.?[0-9A-Z]{3}\.?[0-9A-Z]{3}\/?[0-9A-Z]{4}-?[0-9]{2}$/i, {
      message: 'Máscara do CNPJ inválida',
    }),
  name: min =>
    Yup.string()
      .required(MESSAGES.requiredField)
      .min(min, MESSAGES.minCharacters(min))
      .matches(
        /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u,
        MESSAGES.onlyLetters
      ),
  birthday: Yup.string()
    .required(MESSAGES.date.required)
    .matches(
      /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/,
      {
        message: MESSAGES.date.invalid,
      }
    )
    .test(
      'date-is-in-future',
      MESSAGES.date.invalidFuture,
      birthday => birthday && !dateIsFuture(birthday)
    )
    .test(
      'date-methuselah',
      MESSAGES.date.dateMethuselah,
      birthday => birthday && !dateIsOlderThan(birthday, 100)
    )
    .test(
      'date-very-young',
      MESSAGES.date.dateVeryYoung,
      birthday => birthday && dateIsOlderThan(birthday, 16)
    ),

  cep: Yup.string()
    .required(MESSAGES.requiredField)
    // eslint-disable-next-line no-useless-escape
    .matches(/^\d{5}\-\d{3}$/, {
      message: MESSAGES.validCep,
    }),
  district: Yup.string().when('country', {
    is: val => val === 'BR',
    then: Yup.string().required(MESSAGES.requiredField),
  }),
  password: Yup.string()
    .required(MESSAGES.password.invalid)
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*_#?&]{8,}$/,
      MESSAGES.password.invalid
    ),
  passwordConfirmation: Yup.string()
    .required(MESSAGES.password.notSame)
    .oneOf([Yup.ref('password'), null], MESSAGES.password.notSame),
  telefone: Yup.string()
    .required(MESSAGES.requiredField)
    .matches(
      /(\([1-9][0-9]\)?|[1-9][0-9])\s?([9]{1})?([0-9]{4})-?([0-9]{4})$/gm,
      '* Telefone inválido'
    ),
};

export default VALIDATIONS;
